<template>
  <div class="player" v-show="isPlayOne">
        <audio
        @timeupdate="onTimeupdate"
        @loadedmetadata="onLoadedmetadata"
        ref="audio"
        :src="audioUrl"
        ></audio>
    <img src="./../../static/img/play20190124.png" alt="" style="width: 42px;height: 42px;cursor: pointer;margin-left: -6px;" @click="playAudio()" v-if="!isPlay">
    <img src="./../../static/img/stop20190124.png" alt="" style="width: 42px;height: 42px;cursor: pointer;margin-left: -6px;" @click="playAudio(false)" v-else>
    <Slider  @on-change="changeCurrentTime"	 v-model="sliderTime" style="width: 570px;padding-left: 10px;" :tip-format="formatProcessToolTip"></Slider>
    <span style="padding-left: 25px;color: #b3b3b3;">{{ audio.currentTime | formatSecond}}/{{ audio.maxTime | formatSecond}}</span>
    <Button shape="circle" type="info" ghost style="height: 24px;margin-left: 15px;background: #f2f7ff;border:none;color: #0080ff;width: 44px" size="small" @click="changeSpeed()">{{audio.speed[audio.speedItem] | transSpeed}}</Button>
  </div>
</template>

<script>
// 将整数转换成 时：分：秒的格式
function realFormatSecond(second) {

  let secondType = typeof second

  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)

    let hours = Math.floor(second / 3600)
    second = second - hours * 3600
    let mimute = Math.floor(second / 60)
    second = second - mimute * 60

    return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
  } else {
    return '0:00:00'
  }
}

export default {
  name: "Player",
  props: {
    audioUrl: String,  //音频url
    list: Object,      //数据列表
    playItem: Number,   //播放模式
    playNum: Number,    //当前播放第几句
    isPlayOne: Boolean,  //是否单句播放
    playTab: Boolean,   //全文播放还是标记播放
    collectionIndex: Array, //当前标记的所有单句
    spacingItem:Number  //当前是第几个间隔
  },
  mounted() {
    // this.keyDown()
  },
  data() {
    return {
      sliderTime: 0,     //当前播放进度百分比
      isPlay: false,    //音频是否正在播放
      audio: {
        playing: true,  // 该字段是音频是否处于播放状态的属性
        currentTime: 0, // 音频当前播放时长
        maxTime: 0,     // 音频最大播放时长
        speed: ['1.0', '1.2', '1.5', '0.8'],  //播放速度列表
        speedItem: 0,    //当前选中第几个播放速度
      },
      tabList: [], //标记的所有段落数据
      i: 0 ,   //当前正在播放标记的第几句
      num:0    //当前正在播放第几遍
    }
  },
  watch: {
    audio: {
      handler(newObj, oldObj) {
        let time = newObj.currentTime
        let list = this.tabList
        let max = list.length

        if (this.i === max && max) {
          this.i = 0;
          this.playAudio(false)
        }

        if (!this.playTab && this.collectionIndex.length && this.isPlay) {   //标记播放

          if (time > list[this.i].endTime) {
            this.i = this.i + 1
            this.$refs.audio.currentTime = list[this.i].startTime
          }

        }

          if(this.playItem){     //播放模式
            let space = 0
            switch (this.spacingItem) {
              case 0:
                space = 0
                break;
              case 1:
                space = 2000
                break;
              case 2:
                space = 5000
                break;
            }
            let start = this.list.originalList[this.playNum].listenList[0].timeBeg
            console.log(time);
            console.log(start);
            console.log("当前播放第"+this.playNum+"句");
            console.log("播放第"+(this.num)+"遍");
            switch (this.playItem) {
              case 1:
                if( time > start ){
                  this.playAudio(false)
                }
                break;
              case 2:
                if( time >= start ){
                  this.num = this.num + 1
                  this.playAudio(false)
                  this.$refs.audio.currentTime = this.list.originalList[this.playNum-1].listenList[0].timeBeg
                  if(this.num >= 2){
                    this.playAudio(false)
                    this.num = 0
                  }else{
                    setTimeout(()=>{
                      this.playAudio()
                    },space)
                  }
                }
                break;
              case 3:
                if( time > start ){
                  this.num = this.num + 1
                  this.playAudio(false)
                  this.$refs.audio.currentTime = this.list.originalList[this.playNum-1].listenList[0].timeBeg
                  if(this.num>=5){
                    this.playAudio(false)
                    this.num = 0
                  }else{
                    setTimeout(()=>{
                      this.playAudio()
                    },space)
                  }
                }
                break;
              case 4:
                if( time > start ){
                  this.playAudio(false)
                  this.$refs.audio.currentTime = this.list.originalList[this.playNum-1].listenList[0].timeBeg
                  setTimeout(()=>{
                    this.playAudio()
                  },space)
                }
                break;
              case 5:
                if( time > start ){
                  this.num = 0
                  console.log(1213);
                  // this.playAudio(false)
                  // this.$refs.audio.currentTime = this.list.originalList[this.playNum-1].listenList[0].timeBeg
                }
              break;
            }
          }
      },
      deep: true
    },
    playTab(tab) {
      this.playAudio(false)
    },
  },
  methods:{
    playText(index,start,end){
      this.num = 0
      this.$refs.audio.currentTime = start
    },
    playAudio(flag = true){   //音频播放暂停方法
      let audio = this.$refs.audio
         if(!this.playTab){    //如果是标记播放
            let arr = this.collectionIndex
            let TimeList = []
              arr.forEach(item=>{
                TimeList.push({
                  startTime:this.list.originalList[item].listenList[0].timeBeg,
                  endTime:this.list.originalList[item].listenList[0].timeEnd,
                  number:item
                })
              })
            this.tabList = TimeList
            this.$refs.audio.currentTime = TimeList[0].startTime
          }
      if(flag){
        audio.play()
      }else{
        audio.pause()
      }
      this.isPlay = flag
      this.$emit('isPlays',this.isPlay)
    },
    playOnes(index,isPlay){   //单句列表播放按钮
      let audio = this.$refs.audio
      if(isPlay){
        this.playAudio(false)
      }else{
        this.playAudio()
      }
    },
    nextSentence(flag){  //上一句 false 下一句 true
      this.num = 0
      let audio = this.$refs.audio
      for(let i = 0 ; i< this.list.originalList.length ; i++){
        let startTime = this.list.originalList[i].listenList[0].timeBeg
        let endTime = this.list.originalList[i].listenList[0].timeEnd
        let currentTime = this.audio.currentTime
        if(currentTime >= startTime && currentTime < endTime){
          if(flag){
            this.$refs.audio.currentTime = this.list.originalList[i+1].listenList[0].timeBeg
          }else{
            if(i<1){
              console.log(123);
              return

            }
            this.$refs.audio.currentTime = this.list.originalList[i-1].listenList[0].timeBeg
          }
          console.log(this.list.originalList[i+1].listenList[0].timeBeg)
        }
      }
      console.log(this.$refs.audio.currentTime);

      // this.playAudio()
    },
    changeSpeed() {
       this.audio.speedItem ++
       if(this.audio.speedItem === this.audio.speed.length){
         this.audio.speedItem = 0
       }
       this.$refs.audio.playbackRate = this.audio.speed[this.audio.speedItem]
       console.log(this.audio.speedItem);
    },
    changeCurrentTime(index) {
      let currentTime = index / 100 * this.audio.maxTime
      this.$refs.audio.currentTime = currentTime
    },
     // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate(res) {
      this.$emit('sendTime',res.target.currentTime)
      this.audio.currentTime = res.target.currentTime
      this.sliderTime = parseInt(this.audio.currentTime / this.audio.maxTime * 100)
      if(this.sliderTime === 100){
        this.isPlay =false
      }
    },
    onLoadedmetadata(res) {
      console.log('loadedmetadata')
      console.log(res)
      this.audio.maxTime = parseInt(res.target.duration)
    },
    formatProcessToolTip(index = 0) {
      index = parseInt(this.audio.maxTime / 100 * index)
      return realFormatSecond(index)
    },
  },
  filters:{
    // 将整数转化成时分秒
    formatSecond(second = 0) {
      return realFormatSecond(second)
    },
    transSpeed(value) {
      return 'X'+ value
    }
  }
}
</script>
<style>
  .ivu-slider-button-wrap{
    top: -7px;
  }
</style>
<style lang="stylus" scoped>
.player
      display: flex
      width: 800px
      align-items: center
      border: 1px solid #e5efff
      border-radius: 25px;
      padding 2px 10px
    .player-right
      margin-left 50px
      p
        cursor pointer
        border: solid 1px #7fbfff;
        width: 80px;
        height: 24px;
        border-radius: 12px;
        display flex
        align-items center
        span
          text-align center
          width: 40px;
          height: 24px;
          line-height 24px
          color: #3d9eff;
        span:first-child
          border-radius: 12px 0px 0px 12px;
          background #7fbfff
          color #fff
</style>



// WEBPACK FOOTER //
// src/components/Player.vue